module.exports = __webpack_public_path__ + "static/media/text.18da6fe2.gif";